module.exports = __webpack_public_path__ + "img/request.eedf28ce.svg";